var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "component-check",
      class: _vm.computedClass,
      on: { click: _vm.handleClickCheckbox }
    },
    [
      _c("div", { staticClass: "component-check-render" }),
      _c("div", {
        staticClass: "component-label-render w-normal",
        domProps: { innerHTML: _vm._s(_vm.label) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }